import type {
  ApiResponseCompanyInfoResponse,
  ApiResponseGetJobResponse,
  GetJobsRequest,
} from "../../../shared/types/api";
import { httpClient } from "../http-client";
import { NEW_API_ENDPOINTS } from "../../../shared/constants/api";
import { CompanyMachineApiService } from "./company-machine-api-service";

export class CompanyJobApiService {
  async getJobs(request: GetJobsRequest): Promise<ApiResponseGetJobResponse> {
    const response = await httpClient.get<ApiResponseGetJobResponse>(
      NEW_API_ENDPOINTS.companyJobController.GET(request.companyId, request.machineId),
    );

    if (response.data.errorCode) {
      throw new Error(
        response.data.errorMsg || "작업을 가져오지 못했습니다.",
      );
    }

    return response.data;
  }
}

export const companyJobApiService = new CompanyJobApiService();